import { render, staticRenderFns } from "./Cotizador.vue?vue&type=template&id=fdace5fa"
import script from "./Cotizador.vue?vue&type=script&lang=js"
export * from "./Cotizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports